// play nice, eslint.
/* global window */

import './src/styles/global.css';

import { getUserId } from './src/utils/getUserId';

export { wrapRootElement, wrapPageElement } from './gatsby-shared';

const sendGtmPageviewEvent = () => {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer?.push({
    event: 'pageview',
    // eslint-disable-next-line no-undef
    userId: getUserId(),
    // eslint-disable-next-line no-undef
    storeCode: process.env.GATSBY_REGION,
    // eslint-disable-next-line no-undef
    userType: process.env.GATSBY_IS_PRO === 'true' ? 'B2B' : 'B2C',
    // eslint-disable-next-line no-undef
    pagePath: document.location.pathname + document.location.search,
    // eslint-disable-next-line no-undef
    originalLocation: document.location.href,
  });
};

/**
 * @type {import('gatsby').GatsbyBrowser['onRouteUpdate']}
 */
export const onRouteUpdate = () => {
  // eslint-disable-next-line no-undef
  if (process.env.GATSBY_IS_PRODUCTION === 'true') {
    if (window.dataLayer) {
      // Google Tag Manager has already been loaded
      sendGtmPageviewEvent();
    } else {
      window.addEventListener('gtm_loaded', function () {
        // Google Tag Manager has been loaded
        sendGtmPageviewEvent();
      });
    }
  }
};

export const shouldUpdateScroll = ({ routerProps }) =>
  !routerProps.location.state?.disableScrollUpdate;
